<template>
  <div  class="banner"> 
		
		
		<div class="row">
			<div class="item center">
				<img style="    width: 90%;
    margin-left: 5%;" :src="bannerImg" />
				 
			</div> 
		</div>
  </div>
</template>

<script> 

import { mapState } from 'vuex'
export default {
  name: 'banner',
  props : ['bannerImg'],
  data(){
	  return {
		  
	  }
  },
  computed: mapState([
  			  'init' 
  ]),
  created(){
	 
  },
  components: {
     
  }
}
</script>

<style>
	.banner{
		 width: 100%;
	}
	
	.banner .row{
		display: flex; 
		flex-wrap : nowrap;
		justify-content: space-around;
	}
	
	.banner .row .item{   
		display: flex;
		
	}
	
	.banner .row .item.center{
		align-items : center;
	}
	
	.banner .row .item img{
		width: 100%;
	}
	
	.banner .row.center{
		justify-content:center;
	}
	
	.full{
		width: 100% !important;
	}
</style>
